import React from 'react';

const Loader = props => (
  <div className="afd-story afd-story--loading"></div>
);

export default Loader;
